import { makeStyles } from '@material-ui/core/styles';
import { Theme } from 'enum';

export const useStyle = makeStyles((theme) => {
    const isDarkMode = theme.palette.type === Theme.Dark;
    return {
        container: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            '& .MuiDivider-root': {
                backgroundColor: isDarkMode ? 'rgb(50,50,50)' : 'rgb(240,240,240)',
            },
        },
        content: {
            display: 'flex',
            width: '100%',
        },
        middleSection: {
            padding: theme.spacing(5, 0),
        },
        middleSectionContent: {
            width: '100%',
            display: 'flex',
            flex: 1,
            justifyContent: 'space-between',
            flexDirection: 'row',
            '& a': {
                textDecoration: 'none',
                color: theme.palette.text.secondary,
                width: 'fit-content',
                '& p': {
                    width: 'fit-content',
                    margin: theme.spacing(1.5, 0),
                    fontWeight: 400,
                },
                '&:hover': {
                    textDecoration: 'underline',
                },
            },
        },
        middleLeftSide: {
            flex: 1,
            fontSize: '15px !important',
        },
        list: {
            display: 'flex',
            flexDirection: 'column',
        },
        bottomSection: {
            padding: theme.spacing(3, 0),
            marginBottom: theme.spacing(8),
            display: 'flex',
            justifyContent: 'space-between',
            [theme.breakpoints.down('xs')]: {
                flexDirection: 'column',
                alignItems: 'center',
            },
        },
        info: {
            display: 'flex',
            alignItems: 'center',
            [theme.breakpoints.down('xs')]: {
                flexDirection: 'column',
            },
        },
        socials: {
            display: 'flex',
            alignItems: 'center',
            [theme.breakpoints.down('xs')]: {
                flexDirection: 'column',
            },
        },
        languageWrapper: {
            display: 'flex',
            justifyContent: 'flex-end',
            [theme.breakpoints.down('xs')]: {
                justifyContent: 'center',
            },
            minWidth: 160,
        },
        language: {
            borderRadius: 50,
            color: theme.palette.text.secondary,
            textTransform: 'none',
            fontWeight: 600,
            textAlign: 'left',
            marginLeft: theme.spacing(1),
            '&:hover': {
                backgroundColor: theme.palette.background.default,
            },
            [theme.breakpoints.down('xs')]: {
                marginLeft: 0,
                marginTop: theme.spacing(1),
            },
        },
        copyright: {
            fontWeight: 500,
            marginLeft: theme.spacing(2),
            [theme.breakpoints.down('xs')]: {
                marginLeft: 0,
                margin: theme.spacing(1.5, 0),
            },
        },
    };
});
